export const BULK_PDF_EXPORT_ROUTE_NAMES = {
  MANAGE: "manageBulkPdf",
} as const;

export type BulkPdfExportRouteName =
  (typeof BULK_PDF_EXPORT_ROUTE_NAMES)[keyof typeof BULK_PDF_EXPORT_ROUTE_NAMES];
